<template>
  <div>
    <div
      class="mx-auto my-4 flex flex-row flex-wrap items-center justify-center gap-4 px-3 text-center text-4xl md:max-w-screen-lg md:px-0"
    >
      <CogIcon class="h-[1em] w-[1em] shrink-0 text-primary" />

      <h1>{{ $t("pages.account.settings.title") }}</h1>
      <AccountEmailValidationAlert v-if="showEmailValidationAlert || showEmailNotification" />
    </div>

    <div class="relative bg-[#F0FBFB] px-4 py-10 lg:px-0">
      <div class="mx-auto flex w-full max-w-[1248px] flex-row flex-wrap gap-4">
        <div class="basis-82">
          <div class="pl-2">
            <BaseButton
              @buttonClicked="backToDashboard"
              :text="`${$t('pages.account.dashboard.title')}`"
              class="mt-4 h-10 w-fit text-[1rem]"
              variant="outlined"
            >
              <template #icon>
                <ArrowLeftIcon />
              </template>
            </BaseButton>
          </div>

          <BaseTableOfContent
            :content-ref="conditionalContent"
            header-tag="h3"
            :transparent-background="true"
            :show-header="false"
            class="top-0"
            anchor-class="text-black text-[1rem]"
            active-anchor-class="font-bold text-black"
            auto-focus-first
          />
        </div>

        <div class="flex flex-1 flex-col gap-14" ref="conditionalContent">
          <div
            v-for="[section, options] in AccountSettingsSections"
            :key="options.name"
            v-show="
              ((options.requiresProfileDetails && profile) || !options.requiresProfileDetails) &&
              (options.name !== 'NewEmail' || showNewEmailSection)
            "
          >
            <!--in aove conditions we need to only check showNewEmailSection for NewEmail component-->
            <Component
              :is="section"
              v-if="
                ((options.requiresProfileDetails && profile) || !options.requiresProfileDetails) &&
                (options.name !== 'NewEmail' || showNewEmailSection)
              "
              :profileDetails="profile"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useProfileStore } from "@/stores/profile";
import { CogIcon } from "@heroicons/vue/outline";
import ArrowLeftIcon from "~/components/icons/ArrowLeft.vue";
import AccountSettingsSections from "./sections";
const route = useRoute();
const showEmailValidationAlert = computed(() => {
  return route.query.email_validation_alert === "1";
});

const conditionalContent = ref(null);

const profileStore = useProfileStore();
const showEmailNotification = ref(false);

await profileStore.fetchProfile();
const profile = computed(() => profileStore.profile);

const showNewEmailSection = computed(() => {
  return profile.value?.is_updated_email_verified === false && profile.value?.updated_email !== null;
});

const backToDashboard = async () => {
  const path = "/account";
  const localePath = useLocalePath();
  await navigateTo(
    localePath({
      path: path,
    })
  );
};

const pagePath = "/account/settings";
onMounted(() => {
  if (profileStore.shouldShowEmailNotification(pagePath)) {
    showEmailNotification.value = true;

    // Mark it seen, but don't hide it right now
    profileStore.markEmailNotificationSeen(pagePath);
  }
});
</script>
